module.exports = __webpack_public_path__ + "media/images/app/header/logo-f0b4abc877cf4e296fafd70599cd4d46.svg";